<template>
  <div class="account-received-resumes _offers">
    <div class="account-received-resumes__title">{{$tReceived('Received offers')}}</div>
    <div class=" account-received-resumes__inner">
      <div class="account-received-resumes">
          <ReceivedOffersList class="account-received-resumes__list"/>
      </div>
    </div>

  </div>
</template>

<script>
  import ReceivedOffersList from "../../components/ReceivedOffersList";


  export default {
    components: {
      ReceivedOffersList
    },
    data() {
      return {
        activeTab: 0,
        queryParamsNames: ['page','order_by'],
      }
    },
    computed: {
      queryParams() {
        const params = {}

        for (let name of this.queryParamsNames) {
          let value = this.$route.query[name]
          if (value) {
            params[name] = value
          }
        }
        return params
      },

    },
    methods: {

      age(date) {
        if(date) {
          const currentYear = new Date().getFullYear()
          return currentYear - (+date.slice(-4))
        }
      },

      /*isNewResume(date) {
          let currentDate = new Date()
          let createdDate = new Date(date)

          return false
      }*/

    }
  }
</script>

<style lang="less">

</style>
